// extracted by mini-css-extract-plugin
export var block = "style-module--block--1108e";
export var blockChild = "style-module--block--child--0726b";
export var blockParent = "style-module--block--parent--64e86";
export var block__text = "style-module--block__text--77dca";
export var block__title = "style-module--block__title--d612e";
export var get = "style-module--get--559e8";
export var wrap = "style-module--wrap--480f6";